var View = require('views/base/view');
const DOMPurify = require('dompurify');

var QuestionView = View.extend({
  autoRender: true,
  getTemplateFunction: function() {
    return require('./templates/question/' + this.model.get('question_template'));
  },
  initialize: function() {
    if(this.model.get('question_template') === 'fill_in_the_blank') {
      this.on('addedToParent', function() {
        var questionText = DOMPurify.sanitize(this.$('.question_text').html());
        if(questionText.indexOf('{{answer}}') >= 0) {
          var pre = questionText.substring(0, questionText.indexOf('{{answer}}'));
          var post = questionText.substring(questionText.indexOf('{{answer}}') + 10, questionText.length);
          this.$('.question_text').html(DOMPurify.sanitize(pre));
          this.$('.question_text').append(this.$('.question_element'));
          this.$('.question_text').append(post);
        }
      });
    }
    View.prototype.initialize.apply(this, arguments);
  }
});

module.exports = QuestionView;